import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Company } from "../../models/Companies";
import { CustomerSettings } from "../../models/Customers";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Customer settings form
 */

export class CustomerSettingsForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.modelClass = CustomerSettings;
    this.imagePreview = [];
    this.fields = [{
      label: 'Населенный пункт',
      name: 'cityId',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      required: false,
      props: {
        common: {
          dataState: StateSelector.cities.list,
          dataFetch: DispatchSelector.cities.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        },
        web: {// renderItem: (item) => (<span></span>)
        },
        native: {
          renderItem: {
            key: 'list',
            value: 'id',
            label: 'title'
          }
        }
      }
    }, {
      label: 'E-mail',
      name: 'email',
      required: false,
      trim: true
    }, {
      label: 'Верификация e-mail',
      name: 'isEmailVerified',
      type: BaseForm.TYPES.TOGGLE,
      required: false
    }, {
      label: 'Телефон',
      name: 'phone',
      props: {
        common: {
          maskType: BaseForm.MASK_TYPES.PHONE
        },
        native: {
          keyboardType: 'number-pad'
        }
      }
    }, {
      label: 'Верификация телефона',
      name: 'isPhoneVerified',
      type: BaseForm.TYPES.TOGGLE,
      required: false
    }, // {
    // 	label: 'Аватар',
    // 	name:  'image',
    // 	type:  BaseForm.TYPES.IMAGE,
    // 	props: {
    // 		web: {
    // 			previews:  () => this.imagePreview,
    // 			// String or function
    // 			postUrl:   this.createImageUrl(CustomersApi.uploadAvatar),
    // 			deleteUrl: this.createImageUrl(CustomersApi.deleteAvatar),
    // 		},
    // 	},
    // },
    {
      label: 'Баллы',
      name: 'params.points',
      required: false
    }, {
      label: 'ID Терминала',
      name: 'params.terminalZoneId',
      required: false
    }, {
      label: 'FRID Терминала',
      name: 'params.terminalFRId',
      required: false
    }, {
      label: 'ID метки для табельного номера',
      name: 'params.baseId',
      required: false
    }, {
      label: 'Склад',
      name: 'params.stockId',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      required: false,
      props: {
        common: {
          dataState: StateSelector.companies.list,
          dataFetch: DispatchSelector.companies.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            },
            type: Company.types.warehouse
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        },
        web: {// renderItem: (item) => (<span></span>)
        },
        native: {
          renderItem: {
            key: 'list',
            value: 'id',
            label: 'title'
          }
        }
      }
    }, {
      label: 'Цвет фона баннера',
      name: 'params.bannerBgColor',
      type: BaseForm.TYPES.COLOR_PICKER,
      required: false
    }];
    this.dispatchUpdateForm = DispatchSelector.customersSettings.update;
    this.responseUpdateState = StateSelector.customersSettings.update;
  }

  /**
   * @inheritDoc
   */
  setDefault(field, value) {
    if (field === 'image') {
      if (value.indexOf('default.jpg') === -1) {
        this.imagePreview.push({
          url: value
        });
      }

      return this;
    }

    return super.setDefault(field, value);
  }

}